var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 2.3,
    width: 597.7,
    height: 597.7,
    rx: 86.32,
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.22,
    y: 94.76,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.77,
    y: 94.33,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.26,
    y: 95.03,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 245.31,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.77,
    y: 245.31,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.97,
    y: 245.59,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 396.57,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.77,
    y: 396.84,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.97,
    y: 396.84,
    width: 109.22,
    height: 109.22,
    rx: 25,
    fill: "#bfebff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cc57a65764bcaa2087ba0dfde1c5e626.svg";
export { ForwardRef as ReactComponent };